import PropTypes from 'prop-types'
import { useState } from 'react'

import { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'
import { trackEvent } from 'global-utils/Analytics'
import System from 'system'
import { Info, VerificationCodeInput } from 'ui'

import { catchError, map } from 'rxjs/operators'

const VerifyPasswordResetCode = ({ data }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const requestValidateCode = (code) => {
    setLoading(true)

    trackEvent('Authentication', 'Password Reset', 'Code Verification')

    const $action = epicServerRequest('post', `${System.api_url}/auth/password/reset/code`, {}, { ...data, code }).pipe(
      map(
        epicResponseHandler((response) => {
          if (response.data?.[0]?.redirect) {
            if (process.env.NODE_ENV === 'development') {
              response.data[0].redirect = `${System.url}/${response.data[0].redirect
                .split('//')
                .pop()
                .split('/')
                .slice(1)
                .join('/')}`
            }
            document.location.href = response.data[0].redirect
          }
          setLoading(false)
          return {}
        }, {}),
      ),
      catchError(
        epicErrorHandler((response) => {
          setLoading(false)
          setError(response?.error?.msg || 'Error al verificar.')
          return {}
        }, {}),
      ),
    )

    $action.subscribe(Function.prototype)
  }

  return (
    <div className="flex flex-col gap-2 text-sm">
      <div>
        Te hemos enviado un <b>código</b> a tu email; válido por 5 minutos.
      </div>
      <div className="text-sm px-2">
        Por favor revisa tu bandeja de entrada y <b>spam</b>.
      </div>
      <b>Escríbelo a continuación:</b>
      <VerificationCodeInput disabled={loading} loading={loading} onComplete={requestValidateCode} />
      {!!error && (
        <Info accent="red" icon="warning sign">
          {error}
        </Info>
      )}
    </div>
  )
}

VerifyPasswordResetCode.propTypes = {
  data: PropTypes.shape({}).isRequired,
}

export default VerifyPasswordResetCode
